import { render, staticRenderFns } from "./FooterMenuBasic.vue?vue&type=template&id=32502ff0&scoped=true&"
import script from "./FooterMenuBasic.vue?vue&type=script&lang=js&"
export * from "./FooterMenuBasic.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenuBasic.vue?vue&type=style&index=0&id=32502ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32502ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCardText,VFooter})
